export default {
  selectEnterpriseEarnings: (state) => state.enterpriseEarnings,
  selectEnterpriseCompPlan: (state) => state.enterpriseEarnings.enterpriseCompPlan,
  selectEnterpriseEarningsFilters: (state) => state.enterpriseEarnings.filters,
};
